import { Issue } from "generated-graphql/graphql";

import { DocumentOption } from "./types";

/**
 * Routing predicate for the HMBP document modal. Returns true when the
 * option picker should be the initial step — either because the section
 * has issues to surface, or because no option has been chosen yet. Returns
 * false to deep-link past the picker into the selected option's detail
 * step, which is only appropriate when the section is otherwise clean.
 */
export function shouldOpenAtStepOne(
  issues: Issue[],
  persistedDocumentOption: DocumentOption | null
): boolean {
  if (issues.length > 0) return true;
  if (persistedDocumentOption === null) return true;
  return false;
}
